module.exports = __webpack_public_path__ + "static/media/pokedex-ios.81873cf6.png";